import sfappcss from './App.module.css';
import Navbar from './Components/Navbar/Navbar'; 
import Main from './Components/Main/Main.jsx';
import Footer from './Components/Footer/Footer.jsx';
import FormContact from '../Form/FormContact.jsx';

function Snippetflow() {
  
  return (
    <div className={sfappcss["App"]}>
      <Navbar />
      <Main />
      <div style={{position:'relative', top:"70px"}}><FormContact /></div>
      <Footer /> 
    </div>
  );
}

export default Snippetflow;
